
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/stores/appointment/[country]/[storeslug]",
      function () {
        return require("private-next-pages/[lang]/stores/appointment/[country]/[storeslug]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/stores/appointment/[country]/[storeslug]"])
      });
    }
  